jQuery(document).ready(function ($) {
	if ($("body").hasClass("post-type-archive-investments")) {
		const archive = document.getElementById("archive_main");
		const activeFilters = document.getElementById("active-filters");

		let data = {
			action: "archive_filter_investments",
			post_type: "investments",
			page: 1,
			search: "",
			filters: null,
		};

		$("#investsearch").on("input", function () {
			console.log("input");

			const searchQuery = $(this).val();
			console.log(searchQuery);

			data.search = searchQuery;
			// data.page = 1; // Reset the page to 1 when performing a new search
			sendAjaxRequest(data);
		});

		const filters = []; // object array { dropdown: string, value: string }

		// change page
		$(
			".pagination_wrapper .arrow-button, .pagination_wrapper .pagination_custom"
		).on("click keypress", (e) => {
			if (e.type == "click" || e.key == "Enter") {
				const { newPage, prevPage, nextPage } = getNewPageNumbers(e);
				data.page = newPage;

				sendAjaxRequest(data, () => {
					updatePagination(
						newPage,
						$(".pagination_custom.last").data("page"),
						prevPage,
						nextPage
					);

					if (newPage > 1) {
						toggleShowPagination(true);
					}
				});
			}
		});

		// remove all filters
		$("#filters label[for=view_all], #reset_filters").on(
			"click keypress",
			(e) => {
				if (e.type == "click" || e.key == "Enter") {
					emptyObject(filters);
					resetDropdowns();

					data.filters = null;
					data.page = 1;
					filters.length = 0;
					updateActiveFiltersHTML();

					sendAjaxRequest(data);
				}
			}
		);
		// select filter
		$(".select-dropdown .options .link").on("click keypress", (e) => {
			if (e.type == "click" || e.key == "Enter") {
				const target = $(e.target);
				const dropdown_id = target.closest(".select-dropdown").attr("id");
				const selected = target.data("select");

				// create the object to push to filters
				const checkedFilter = {
					dropdown: getFilterKey(dropdown_id),
					value: selected,
				};

				const containsFilter = filters.some(
					(filter) =>
						filter.dropdown === checkedFilter.dropdown &&
						filter.value === checkedFilter.value
				);

				// only push the object if its not already in filters
				if (!containsFilter) {
					filters.push(checkedFilter);
					updateActiveFiltersHTML();
				}

				// go to the first page of the new results
				data.page = 1;
				data.filters = filters;
				sendAjaxRequest(data);

				removePaginationClasses();
				$('.pagination_custom[data-page="2"]').addClass(
					paginationNextPageClassName
				);
			}
		});

		function setActiveFilters() {
			updateActiveFiltersHTML();

			data.page = 1;
			data.filters = filters;
			sendAjaxRequest(data);
		}

		function setActiveFilterEventListeners() {
			// remove click event listeners from all filters and re-add
			$("#active-filters .remove-filter").off("click");

			$("#active-filters .remove-filter").on("click", ({ target }) => {
				removeFilter(target.getAttribute("data-index"));
			});
		}

		function removeFilter(index) {
			filters.splice(index, 1);
			setActiveFilters();
		}

		function updateActiveFiltersHTML() {
			// make a string of all the html for the active filters, then replace activeFilters.innerHTML with the HTML string, then reset event listeners
			const filterHTML = filters
				.map(
					(filter, index) => `<span class="filter">
                    <span class="filter-value">${filter.value}</span>
                    <span class="remove-filter" data-index="${index}">X</span>
                    </span>
                `
				)
				.join("");

			activeFilters.innerHTML = filterHTML;
			setActiveFilterEventListeners();
		}

		function sendAjaxRequest(data, callback) {
			$.ajax({
				url: ajax_url,
				type: "post",
				dataType: "json",
				data: data,

				success: ({ blog_data, pages } = res) => {
					$(".pagination_custom.last").removeClass("last");
					$(`.pagination_custom[data-page='${pages}']`).addClass("last");

					$(`.pagination_custom.${paginationCurrentPageClassName}`).removeClass(
						paginationCurrentPageClassName
					);
					$(`.pagination_custom[data-page="${data.page}"]`).addClass(
						paginationCurrentPageClassName
					);

					archive.innerHTML = "";

					blog_data?.forEach((result, index) => {
						archive.innerHTML += investment_html(result, index);
					});

					toggleShowResults(archive, blog_data ? "show" : "hide");
					toggleShowPagination(pages > 1);

					scroll(document.getElementById("archive"));

					if (callback) {
						callback();
					}

					// $(".case_study:first-of-type").focus();

					// No Result Found
					// if (!blog_data || blog_data.length < 1) {
					// 	console.log("No Results Found");
					// }
				},

				error: function (xhr, status, error) {
					console.error(xhr.responseText);
					if (xhr.status == 500) {
						// Handle 500 error response
						toggleShowResults(archive, "hide");
					}
				},
			});
		}

		function investment_html(data, count) {
			return `
				<a href="${data.permalink}" class="case_study col-md-4 is-link ${
				count < 3 ? "row-1 " : ""
			} ${(count - 1) % 3 == 0 ? "add_margin " : ""}" data-count="${count}">
				<div class="content_wrapper">
					<div class="thumbnail">
						<img width="1600" height="800" src="${
							data.thumbnail
						}" class="attachment-full size-full wp-post-image" alt="" decoding="async" loading="lazy" sizes="(max-width: 793px) 100vw, 1600px">
						<img class="logo" src="${data.logo}" alt="">
					</div>
					<div class="info">
						<h3 class="title text-clamp text-clamp-2">${data.title}</h3>
						<p class="excerpt text-clamp text-clamp-3">${data.excerpt}</p>
						<div class="link"><span>Read more</span> 
						<svg xmlns="http://www.w3.org/2000/svg" width="20" height="17.279" viewBox="0 0 20 17.279">
							<path id="Path_42" data-name="Path 42" d="M8.032,0V17.86L.792,10.568,0,11.361,8.639,20l8.64-8.665-.793-.793L9.221,17.86V0Z" transform="translate(0 17.279) rotate(-90)" fill="#ed6b45"></path>
						</svg>
						</div>
					</div>
				</div>
			</a>`;
		}
	}
});
